export default {
  beforeCreate() {
    this.loadData();
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
    this.initDM();
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  data() {
    return {
      user: {
        name: 'Learner',
        class: 10,
        email: 'student@example.com',
        phone: '0123456789',
        gender: 'male',
        birthday: '2000-01-01',
        about: 'myself curious student',
        address: 'sutdent address '
      },
      avatar: './static/user-female-circle.png',
      darkMode: false,
      DM: {}
    };
  },
  methods: {
    initDM() {
      var self = this;
      window.dmAsyncInit = function () {
        DM.init({
          apiKey: 'your app id',
          status: false,
          cookie: false
        });
        self.DM = DM;
        console.log('DM loaded');
      };
      (function () {
        var e = document.createElement('script');
        e.async = true;
        e.src = './static/js/all.js';
        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(e, s);
      }());
    },
    loadData() {
      if (!localStorage.getItem('user'))
        localStorage.setItem('user', JSON.stringify(this.user));
      else
        this.user = JSON.parse(localStorage.getItem('user'));
      if (!localStorage.getItem('avatar'))
        localStorage.setItem('avatar', JSON.stringify(this.avatar));
      else
        this.avatar = JSON.parse(localStorage.getItem('avatar'));
      if (!localStorage.getItem('darkMode'))
        localStorage.setItem('darkMode', JSON.stringify(this.darkMode));
      else
        this.darkMode = JSON.parse(localStorage.darkMode);
    }
  },
  on: {
    pageMounted: function (e, page) {
    },
    pageInit: function (e, page) {
      if (this.darkMode) {
        page.$el.find('.toggle input').prop('checked', true);
        this.$$('#app').addClass('theme-dark');
      }
      var self = this;
      page.$el.find('.toggle').on('change', function () {
        var toggle = page.app.toggle.get('.toggle');
        var isDark;
        if (toggle.checked) {
          self.$$('#app').addClass('theme-dark');
          isDark = true;
        } else {
          self.$$('#app').removeClass('theme-dark');
          isDark = false;
        }
        this.darkMode = isDark;
        localStorage.setItem('darkMode', JSON.stringify(isDark));
      });
    },
    pageBeforeIn: function (e, page) {
    },
    pageAfterIn: function (e, page) {
    },
    pageBeforeOut: function (e, page) {
    },
    pageAfterOut: function (e, page) {
    },
    pageBeforeRemove: function (e, page) {
    }
  },
  id: 'f8cc544dc2',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\r\n  <div id="app">\r\n    <!-- Left panel with cover effect -->\r\n    <div class="panel panel-left panel-cover panel-init" data-visible-breakpoint="960">\r\n      <div class="view view-init" data-view="left">\r\n        <div class="page">\r\n          <div class="navbar navbar-transparent" style="height: 96px;">\r\n            <div class="navbar-bg"></div>\r\n            <a href="/profile/" data-view=".view-main" class="panel-close">\r\n              <div class="navbar-inner sliding" style="padding: 10px 20px 5px 10px;">\r\n                <div class="profile-pic nav-page" style="background-image:url(';
      r += c(ctx_1.avatar, ctx_1);
      r += ');"></div>\r\n                <div class="username">';
      r += c(ctx_1.user.name, ctx_1);
      r += '</div>\r\n                <div class="right"><i class="icon f7-icons">arrow_right_circle_fill</i></div>\r\n              </div>\r\n            </a>\r\n          </div>\r\n          <div class="page-content" style="padding-top: 96px;">\r\n            <div class="list no-hairlines no-hairlines-between">\r\n              <ul>\r\n                <li>\r\n                  <a href="/" data-view=".view-main" class="item-link item-content panel-close">\r\n                    <div class="item-media"><i class="icon f7-icons">house</i></div>\r\n                    <div class="item-inner">\r\n                      <div class="item-title">Home</div>\r\n                    </div>\r\n                  </a>\r\n                </li>\r\n                <li>\r\n                  <a href="/analysis/" data-view=".view-main" class="item-link item-content panel-close">\r\n                    <div class="item-media"><i class="icon f7-icons">graph_circle</i></div>\r\n                    <div class="item-inner">\r\n                      <div class="item-title">Learning Analysis</div>\r\n                    </div>\r\n                  </a>\r\n                </li>\r\n                <li class="item-divider">Subjects</li>\r\n                <li>\r\n                  <a href="/history/" data-view=".view-main" class="item-link item-content panel-close">\r\n                    <div class="item-media"><i class="icon f7-icons">rocket</i></div>\r\n                    <div class="item-inner">\r\n                      <div class="item-title">History</div>\r\n                    </div>\r\n                  </a>\r\n                </li>\r\n                <li>\r\n                  <a href="/geography/" data-view=".view-main" class="item-link item-content panel-close">\r\n                    <div class="item-media"><i class="icon f7-icons">rocket</i></div>\r\n                    <div class="item-inner">\r\n                      <div class="item-title">Geography</div>\r\n                    </div>\r\n                  </a>\r\n                </li>\r\n                <li>\r\n                  <a href="/economics/" data-view=".view-main" class="item-link item-content panel-close">\r\n                    <div class="item-media"><i class="icon f7-icons">rocket</i></div>\r\n                    <div class="item-inner">\r\n                      <div class="item-title">Economics</div>\r\n                    </div>\r\n                  </a>\r\n                </li>\r\n                <li>\r\n                  <a href="/politicalscience/" data-view=".view-main" class="item-link item-content panel-close">\r\n                    <div class="item-media"><i class="icon f7-icons">rocket</i></div>\r\n                    <div class="item-inner">\r\n                      <div class="item-title">Political Science</div>\r\n                    </div>\r\n                  </a>\r\n                </li>\r\n              </ul>\r\n            </div>\r\n            <div class="list no-hairlines no-hairlines-between">\r\n              <ul>\r\n                <li>\r\n                  <a href="/preferences/" data-view=".view-main" class="item-link item-content panel-close">\r\n                    <div class="item-media"><i class="icon f7-icons">gear_alt</i></div>\r\n                    <div class="item-inner">\r\n                      <div class="item-title">Preferences</div>\r\n                    </div>\r\n                  </a>\r\n                </li>\r\n                <li>\r\n                  <a href="/about/" data-view=".view-main" class="item-link item-content panel-close">\r\n                    <div class="item-media"><i class="icon f7-icons">info_circle</i></div>\r\n                    <div class="item-inner">\r\n                      <div class="item-title">About</div>\r\n                    </div>\r\n                  </a>\r\n                </li>\r\n                <li>\r\n                  <a href="#" data-view=".view-main" class="item-link item-content back panel-close">\r\n                    <div class="item-media"><i class="icon f7-icons">chevron_left_circle</i></div>\r\n                    <div class="item-inner">\r\n                      <div class="item-title">Back in history</div>\r\n                    </div>\r\n                  </a>\r\n                </li>\r\n                <li>\r\n                  <div class="item-content">\r\n                    <div class="item-media"><i class="icon f7-icons">circle_righthalf_fill</i></div>\r\n                    <div class="item-inner">\r\n                      <div class="item-title">Dark Mode</div>\r\n                      <div class="item-after">\r\n                        <label class="toggle toggle-init panel-close">\r\n                          <input name="darkmode" type="checkbox" />\r\n                          <span class="toggle-icon"></span>\r\n                        </label>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </li>\r\n              </ul>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <!-- Right panel with reveal effect-->\r\n    <div class="panel panel-right panel-reveal">\r\n      <div class="view">\r\n        <div class="page">\r\n          <div class="navbar">\r\n            <div class="navbar-bg"></div>\r\n            <div class="navbar-inner">\r\n              <div class="title">Right Panel</div>\r\n            </div>\r\n          </div>\r\n          <div class="page-content">\r\n            <div class="block">Right panel content goes here</div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <!-- Your main view, should have "view-main" class -->\r\n    <div class="view view-main view-init safe-areas" data-url="/"></div>\r\n\r\n  </div>\r\n';
      return r;
    }(this);
  },
  style: `
  .username {
    position: relative;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex-shrink: 10;
    font-weight: var(--f7-navbar-title-font-weight);
    display: inline-block;
    line-height: var(--f7-navbar-title-line-height);
    text-align: var(--f7-navbar-title-text-align);
    font-size: var(--f7-navbar-title-font-size);
    margin-left: var(--f7-navbar-title-margin-left);
    margin-right: var(--f7-navbar-title-margin-left);
  }
`,
  styleScoped: false
};